import axios from "axios"
import { IsAuthorized } from "src/authentication/IsAuthorized"
import { getJWT } from "src/helper/localStore/getJWT"


const formatContext = (userName:string) =>{
      let context = ''
      const chats = JSON.parse(localStorage?.getItem('chats') ?? '[]')
      if(chats.length > 0){
        let contextAux = context
        for(let chat of chats?.reverse()){
            if(chat.answer){
                contextAux = `Beto: ${chat.answer}\n${contextAux}`
            }
            if(chat.question){
                contextAux = `${userName}: ${chat.question}\n${contextAux} `
            }
            if(contextAux.length <= 5000){
              context = contextAux
            } else {
              break
            }
        }
      } else {
        context = '-'
      }
      return context
  }

class ChatbotServices {
  async askBot(query: string, queryHistory:string): Promise<any> {
      try {
        const res = await axios.post(`${process.env.REACT_APP_URL_REDMINE}/chatbot/query`, 
      {
          query,
          queryHistory
      },
      {
          headers: { 
              'Content-Type': 'application/json', 
              'authentication-token': getJWT()!
          },
        })
        return res.data
      } catch (error) {
        IsAuthorized(error)
        throw error
      }
    }
  
  async promptNotFound(prompt:string): Promise<any> {
      try {
        const user = JSON.parse(localStorage?.getItem('user') ?? '{}')
        const chat = formatContext( user?.name)
        const res = await axios.post(`${process.env.REACT_APP_URL_NOTIFICATION}/notification/prompt-not-found/`, 
      {
        prompt,
        user:user.email,
        language:user.language,
        chat
      },
      {
          headers: { 
              'Content-Type': 'application/json', 
              'authentication-token': getJWT()!
          },
        })
        return res.data
      } catch (error) {
        IsAuthorized(error)
        throw error
      }
    }
  
  async sendFeedbackMail(prompt:any): Promise<any>{
    try {
        const user = JSON.parse(localStorage?.getItem('user') ?? '{}')
        const chat = formatContext( user?.name)
        const res = await axios.post(`${process.env.REACT_APP_URL_NOTIFICATION}/notification/notify-feedback/`, 
      {
        prompt,
        user:user.email,
        language:user.language,
        chat
      },
      {
          headers: { 
              'Content-Type': 'application/json', 
              'authentication-token': getJWT()!
          },
        })
        return res.data
      } catch (error) {
        IsAuthorized(error)
        throw error
      }
  }
}

export const chatbotServices = new ChatbotServices()